import minMaxInt from "../plugins/utils";

//classes
class ScreenshotCarousel {
    constructor(element){
        //data
        this.element = element;

        this.track = element.querySelector('.ipad-carousel__track');
        this.tabButtons = Array.from(element.querySelectorAll('.ipad-carousel__nav-item button'));
        this.slides = Array.from(element.querySelectorAll('.carousel-slide'));

        this.slideCount = this.slides.length;
        this.currentSlide = 1;
        
        this.containerWidth = 0;
        this.slideWidth = 0;
        this.trackWidth = 0;
        this.trackPosition = 0;

        this.dragActive = false;
        this.clickPosition = 0;

        this.updateCarouselNavigation();
        this.setupResizeObserver(this.element);
    }

    setupResizeObserver(object) {
        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                const entrySize = entry.contentBoxSize
                ? entry.contentBoxSize[0]
                    ? entry.contentBoxSize[0].inlineSize
                    : entry.contentBoxSize.inlineSize
                : entry.contentRect.width;
    
                this.updateContainerWidth(entrySize);
                //ideally i'd like to feed in this function to the set up, but I don't know hwo to then get the entry size into the function.
            }
        })
        
        observer.observe(object.querySelector('.ipad-carousel__container'))
    } // observes slider size, 

    evalDragPosition() {
        this.updateClickPosition(0);
        let endPos = (this.trackPosition / this.slideWidth) + 1;

        if (endPos < this.currentSlide) {
            this.updateCurrentSlide(minMaxInt(1, this.slideCount, this.currentSlide - 1));
        }
        else if (endPos > this.currentSlide) {
            this.updateCurrentSlide(minMaxInt(1, this.slideCount, this.currentSlide + 1));
        } //update slide based on drag position
    }

    updateDragActive(value) {
        if (value) {
            this.track.classList.add('drag-active');
        }
        else {
            this.track.classList.remove('drag-active');
        }
        this.dragActive = value;
    }

    updateClickPosition(value) {
        this.clickPosition = value;
    }

    updateTrackPosition(additional = 0) {
        this.trackPosition = ((this.currentSlide - 1) * this.slideWidth) + additional;
        this.track.style.left = `${this.trackPosition * -1}px`
    }

    updateCarouselNavigation() {
        this.tabButtons.forEach((button, i) => {
            let place  = i + 1;
            button.ariaSelected = place == this.currentSlide;
            button.classList = place == this.currentSlide ? 'active' : '';
        })
        this.slides.forEach((slide, i) => {
            const place = i + 1;
            slide.ariaHidden = place != this.currentSlide;
        })
    }

    updateCurrentSlide(index) {
        this.currentSlide = index;
        this.updateTrackPosition();
        this.updateCarouselNavigation();
    }

    updateSlideWidth(width) {
        this.slideWidth = width;

        this.slides.forEach(slide => {
            slide.style.width = `${this.slideWidth}px`;
        })
    }
    
    updateTrackWidth() {
        this.trackWidth = this.slideCount * this.slideWidth;
        this.track.style.width = `${this.trackWidth}px`;
    }

    updateContainerWidth(width) {
        this.containerWidth = width;
        this.updateSlideWidth(width);
        this.updateTrackWidth();
        this.updateTrackPosition();
    }
}

export default (ScreenshotCarousel);

//fuctions
function press (object, func) {
    object.addEventListener('mousedown', function() {
        func.apply();
    });

    object.addEventListener('touchstart', function() {
        func.apply();
    });
} 

function release (object, func) {
    object.addEventListener('mouseup', function() {
        func.apply(); 
    });
    object.addEventListener('touchend', function() {
        func.apply(); 
    });
    object.addEventListener('mouseleave', function() {
        func.apply(); 
    });
} 

function move(object, func) {
    object.addEventListener('mousemove', function() {
        func.apply();
    })
    object.addEventListener('touchmove', function() {
        func.apply();
    })
}


//application
const carousels = document.querySelectorAll('.ipad-carousel');

carousels.forEach((el) => {
    const carousel = new ScreenshotCarousel(el);

    carousel.tabButtons.forEach((button) => {
        button.addEventListener('click', function() {
            carousel.updateCurrentSlide(button.getAttribute('data-slide'));
        })
    });
    
    press(carousel.track, () => {
        carousel.updateDragActive(true);
        carousel.updateClickPosition(event.pageX);
    });
    
    release(carousel.track, () => {
        if (carousel.dragActive) {
            carousel.updateDragActive(false);
            carousel.evalDragPosition();
        }
    });
    
    move(carousel.track, () => {
        if (carousel.dragActive) {
            carousel.updateTrackPosition((carousel.clickPosition - event.pageX) * 0.65);
        }
    });
})



